export default __webpack_public_path__ + "assets/montenegro-flag.png";